module.exports = __webpack_public_path__ + "img/1F1E7-1F1F1.acb7e1a5.svg";